import React from 'react'

/** Текст підтвердження видалення конкретного запису: resource.settings.deleteConfirmText(item) */
// eslint-disable-next-line no-unused-vars -- false positive: ESLint core rule flags param names in function-type signatures
export type DeleteConfirmText = (item: Record<string, any>) => string | undefined

/** Сирі дані рядка таблиці (трансформер кладе їх у _original) або самого запису */
const rawItem = (item: any): Record<string, any> => item?._original ?? item ?? {}

export const deleteConfirmTextFor = (crudContext: any, item: any): string | undefined => {
    const fn = crudContext?.resource?.settings?.deleteConfirmText as DeleteConfirmText | undefined
    return typeof fn === 'function' ? fn(rawItem(item)) : undefined
}

/**
 * onTableMenuItemsBuild: пункт «Видалити» ядра підтверджується загальним текстом; якщо ресурс
 * задає текст для запису (напр. попередження про запис з ERP у довідниках) — підставляємо його
 * в той самий DeleteMenuItemLabel, нічого іншого в пункті не змінюючи.
 */
export const applyDeleteConfirmText = ({ menuItems, item, crudContext }: any): void => {
    const text = deleteConfirmTextFor(crudContext, item)
    if (!text) return
    const remove = (menuItems as any[]).find((menuItem) => menuItem?.key === 'delete')
    if (remove && React.isValidElement(remove.label)) {
        remove.label = React.cloneElement(remove.label as React.ReactElement<any>, { confirmDescription: text })
    }
}
